module.exports = __webpack_public_path__ + "static/img/ex_b3.a39bc4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_b3.jpg
// module id = PBFV
// module chunks = 1